import { put, call, all, takeEvery, takeLatest } from 'redux-saga/effects'
import { store as reduxStore } from 'index'
import {
  getAppMessages as messageLogs,
  searchAppMessages as searchMessageLogs,
  deleteAppMessageLog as msgLogDelete,
  getModerationMessages as modMessageLogs,
  approveModMessageLogs as modMessageLogsApprove,
  rejectModMessageLogs as modMessageLogsReject,
  getGroupMessages as groupMessageLogs,
  deleteGroupMessageLog as groupMsgLogDelete,
  exportAppMessages as exportMessageLogs,
  getAppMessageByID as messageGet,
  getMessageCategories,
} from 'services/messages'
import { manualOutreach } from 'services/user'
import constants from 'constants'
import _ from 'lodash'
import { getAppHost } from 'helpers'
import actions from './actions'
import groupsActions from '../groups/actions'

export function* GET_MESSAGE_LOGS({ payload }) {
  if (reduxStore.getState().messages.messageLogsLoading) return
  if (payload.type !== 'next') {
    yield put({
      type: actions.SET_STATE,
      payload: {
        messageLogsLoading: true,
      },
    })
  }

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  let msgId = 0

  let loadMoreId = reduxStore.getState().messages.messageLogsLoadMoreId
  let pollingId = reduxStore.getState().messages.messageLogsPollingId

  if (payload.type === 'next') {
    msgId = pollingId
  } else if (payload.type === 'previous') {
    msgId = loadMoreId
  } else payload.type = 'current'

  const filters = payload.filters || {}

  try {
    const success = yield call(
      messageLogs,
      payload.data,
      getAppHost(payload.appSettings),
      payload.type,
      msgId,
      filters,
    )
    const { messageLogs: currentMsgLogs } = reduxStore.getState().messages

    if (success && success.data) {
      let filteredMessages
      if (filters.categories) {
        filteredMessages = _.filter(success.data, function fn(m) {
          return m.type !== 'extension_human-moderation'
        })
      } else {
        filteredMessages = _.filter(success.data, function fn(m) {
          return (
            m.category === 'message' ||
            m.category === 'agentic' ||
            (m.category === 'custom' && m.type !== 'extension_human-moderation')
          )
        })
      }

      filteredMessages = _.reverse(filteredMessages)
      let newMsgLogs = filteredMessages

      if (payload.type === 'previous') {
        newMsgLogs = currentMsgLogs
        newMsgLogs = _.concat(newMsgLogs, filteredMessages)
        const totalMessagesLengthNow = newMsgLogs.length
        const maxMessageLengthOnDom = 100
        if (totalMessagesLengthNow > maxMessageLengthOnDom) {
          newMsgLogs = _.takeRight(newMsgLogs, maxMessageLengthOnDom)
        }
      } else if (payload.type === 'next') {
        if (filteredMessages.length > 0) {
          yield put({
            type: actions.SET_STATE,
            payload: {
              messageLogsLoading: true,
            },
          })
          window.triggerNotification('Fetching new chats', 'success')
          newMsgLogs = _.concat(newMsgLogs, currentMsgLogs)

          const totalMessagesLengthNow = newMsgLogs.length
          const maxMessageLengthOnDom = 100
          if (totalMessagesLengthNow > maxMessageLengthOnDom) {
            newMsgLogs = _.take(newMsgLogs, maxMessageLengthOnDom)
          }
        } else {
          newMsgLogs = currentMsgLogs
        }
      }

      const len = newMsgLogs.length

      if (len > 0) {
        const updatedMessageLogs1 = newMsgLogs
        const pulled1 = _.last(updatedMessageLogs1)

        loadMoreId = pulled1.id

        const updatedMessageLogs2 = newMsgLogs
        const pulled2 = _.first(updatedMessageLogs2)

        pollingId = pulled2.id

        if (
          (payload.type === 'previous' || payload.type === 'current') &&
          success.data.length === 0
        ) {
          loadMoreId = 0
        }
      } else {
        loadMoreId = 0
        pollingId = 0
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          messageLogs: newMsgLogs,
          messageLogsLoading: false,
          messageLogsLoadMoreId: loadMoreId,
          messageLogsPollingId: pollingId,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          messageLogs: [],
          messageLogsLoading: false,
          messageLogsLoadMoreId: 0,
          messageLogsPollingId: 0,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { messageLogsLoading: false },
    })
    window.triggerNotification('Failed to fetch message logs', 'error')
  }
}

export function* GET_MESSAGE_CATEGORIES({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      messageCategoriesLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(
      getMessageCategories,
      payload.data,
      getAppHost(payload.appSettings),
    )

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          messageCategories: success.data,
          messageCategoriesLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          messageCategories: [],
          messageCategoriesLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        messageCategories: [],
        messageCategoriesLoading: false,
      },
    })
  }
}

export function* GET_GROUP_MESSAGE_LOGS({ payload }) {
  // groupMessageLogs / groupMessageLogsLoading are owned by the groups slice (groups/reducers.js)
  yield put({
    type: groupsActions.SET_STATE,
    payload: {
      groupMessageLogsLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active

  try {
    const success = yield call(groupMessageLogs, payload.data, payload.id)

    if (success && success.data) {
      const filteredMessages = _.filter(success.data, function fn(m) {
        return (
          m.category === 'message' ||
          (m.category === 'custom' && m.type !== 'extension_human-moderation')
        )
      })

      yield put({
        type: groupsActions.SET_STATE,
        payload: {
          groupMessageLogs: filteredMessages,
          groupMessageLogsLoading: false,
        },
      })
    } else {
      yield put({
        type: groupsActions.SET_STATE,
        payload: {
          groupMessageLogs: [],
          groupMessageLogsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: groupsActions.SET_STATE,
      payload: { groupMessageLogsLoading: false },
    })
    window.triggerNotification('Failed to fetch group messages', 'error')
  }
}

export function* GET_MOD_MESSAGE_LOGS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      modMessageLogsLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  let msgId = 0
  if (!payload.action) payload.action = 'show_oldest'
  let loadMoreId = reduxStore.getState().messages.modMessageLogsLoadMoreId

  msgId = loadMoreId
  const { modMessageLogs: currentMsgLogs } = reduxStore.getState().messages

  if (payload.action === 'first_load' || payload.action === 'refresh_load') msgId = 0

  try {
    const success = yield call(modMessageLogs, payload.data, getAppHost(payload.appSettings), msgId)

    if (success && success.data) {
      const filteredMessages = _.filter(success.data, function fn(m) {
        return (
          m.category === 'custom' &&
          m.type === 'extension_human-moderation' &&
          m.data.customData !== undefined
        )
      })
      let newModMsgLogs = filteredMessages

      if (filteredMessages.length > 0) {
        yield put({
          type: actions.SET_STATE,
          payload: {
            modMessageLogsLoading: true,
          },
        })
        if (payload.action !== 'first_load' && payload.action !== 'refresh_load') {
          newModMsgLogs = _.concat(currentMsgLogs, newModMsgLogs)
          newModMsgLogs = _.uniqBy(newModMsgLogs, function fn(e) {
            return e.id
          })
        }

        const totalMessagesLengthNow = newModMsgLogs.length
        const maxMessageLengthOnDom = 100
        if (totalMessagesLengthNow > maxMessageLengthOnDom) {
          if (payload.action === 'show_recent') {
            newModMsgLogs = _.takeRight(newModMsgLogs, maxMessageLengthOnDom)
            window.triggerNotification('Fetching new chats', 'success')
          } else {
            newModMsgLogs = _.take(newModMsgLogs, maxMessageLengthOnDom)
          }
        }
      } else if (payload.action === 'refresh_load' && filteredMessages.length === 0) {
        newModMsgLogs = []
      } else {
        newModMsgLogs = currentMsgLogs
      }

      const len = newModMsgLogs.length

      if (len > 0) {
        const updatedMessageLogs1 = newModMsgLogs
        const pulled1 = _.last(updatedMessageLogs1)

        loadMoreId = pulled1.id
      } else {
        loadMoreId = 0
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          modMessageLogs: newModMsgLogs,
          modMessageLogsLoading: false,
          modMessageLogsLoadMoreId: loadMoreId,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          modMessageLogs: [],
          modMessageLogsLoading: false,
          modMessageLogsLoadMoreId: 0,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { modMessageLogsLoading: false },
    })
    window.triggerNotification('Failed to fetch moderation messages', 'error')
  }
}

export function* DELETE_MESSAGE_LOG({ payload }) {
  const { id } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps
  const { messageSearchLogs } = reduxStore.getState().messages

  try {
    const success = yield call(msgLogDelete, id, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      const updatedMessageSearchLogs = messageSearchLogs.filter(msg => msg.id !== id)

      yield put({
        type: actions.GET_MESSAGE_LOGS,
        payload: { currentPage: 1, data: activeApp, type: 'current' },
      })
      yield put({
        type: actions.SET_STATE,
        payload: {
          messageSearchLogs: updatedMessageSearchLogs,
        },
      })
      window.triggerNotification('Chat Deleted', 'success')
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      }
  } catch (error) {
    window.triggerNotification('Failed to delete message', 'error')
  }
}

export function* APPROVE_MOD_MESSAGE({ payload }) {
  const { modMessage } = payload
  const activeApp = reduxStore.getState().apps.active

  try {
    const success = yield call(modMessageLogsApprove, modMessage, activeApp)
    if (success && success.success) {
      yield put({
        type: actions.GET_MOD_MESSAGE_LOGS,
        payload: { currentPage: 1, action: 'refresh_load', data: activeApp, type: 'current' },
      })
      window.triggerNotification('Chat Approved', 'success')
    } else {
      window.triggerNotification('Failed to approve', 'error')
    }
  } catch (error) {
    window.triggerNotification('Failed to approve', 'error')
  }
}

export function* REJECT_MOD_MESSAGE({ payload }) {
  const { modMessage } = payload

  const activeApp = reduxStore.getState().apps.active

  try {
    const success = yield call(modMessageLogsReject, modMessage, activeApp)

    if (success && success.success) {
      yield put({
        type: actions.GET_MOD_MESSAGE_LOGS,
        payload: { currentPage: 1, action: 'refresh_load', data: activeApp, type: 'current' },
      })
      window.triggerNotification('Chat Rejected', 'success')
    } else {
      window.triggerNotification('Failed to reject', 'error')
    }
  } catch (error) {
    window.triggerNotification('Failed to reject', 'error')
  }
}

export function* DELETE_GROUP_MESSAGE_LOG({ payload }) {
  const { id } = payload

  const activeApp = reduxStore.getState().apps.active

  try {
    const success = yield call(groupMsgLogDelete, id, activeApp)

    if (success && success.data) {
      yield put({
        type: actions.GET_GROUP_MESSAGE_LOGS,
        payload: { id, currentPage: 1, data: activeApp },
      })
      window.triggerNotification('Chat deleted', 'success')
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
        window.triggerNotification(success.error.details.name, 'error')
      } else {
        window.triggerNotification('Error deleting message', 'error')
      }
  } catch (error) {
    window.triggerNotification('Failed to delete message', 'error')
  }
}

export function* GET_MESSAGE_SEARCH_LOGS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      messageSearchLogsLoading: true,
      messageSearchExceedsLimit: false,
    },
  })
  if (payload !== undefined && payload.fromDate !== undefined && payload.toDate !== undefined) {
    if (!payload.data) payload.data = reduxStore.getState().apps.active
    if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
    const filters = payload.filters || {}
    const responseTemp = []

    try {
      const success = yield call(
        searchMessageLogs,
        payload.data,
        getAppHost(payload.appSettings),
        payload.fromDate,
        payload.toDate,
        'current',
        0,
        filters,
      )
      let searchResultsExceedsLimit = false
      if (success && success.data) {
        let filteredMessages
        if (filters.categories) {
          filteredMessages = _.filter(success.data, function fn(m) {
            return m.type !== 'extension_human-moderation'
          })
        } else {
          filteredMessages = _.filter(success.data, function fn(m) {
            return (
              m.category === 'message' ||
              m.category === 'agentic' ||
              (m.category === 'custom' && m.type !== 'extension_human-moderation')
            )
          })
        }

        filteredMessages = _.reverse(filteredMessages)
        let newMsgLogs = filteredMessages
        responseTemp.push(success)

        for (let i = 1; i < constants.messages_filter_export_call_limit; i += 1) {
          if (
            responseTemp[i - 1].meta !== undefined &&
            responseTemp[i - 1].meta.previous !== undefined &&
            responseTemp[i - 1].meta.previous.id !== undefined
          ) {
            responseTemp[i] = yield call(
              searchMessageLogs,
              payload.data,
              getAppHost(payload.appSettings),
              responseTemp[i - 1].meta.previous.fromTimestamp,
              responseTemp[i - 1].meta.previous.toTimestamp,
              'previous',
              responseTemp[i - 1].meta.previous.id,
              filters,
            )
            if (responseTemp[i] && responseTemp[i].data) {
              let filteredMessages2
              if (filters.categories) {
                filteredMessages2 = _.filter(responseTemp[i].data, function fn(m) {
                  return m.type !== 'extension_human-moderation'
                })
              } else {
                filteredMessages2 = _.filter(responseTemp[i].data, function fn(m) {
                  return (
                    m.category === 'message' ||
                    (m.category === 'custom' && m.type !== 'extension_human-moderation')
                  )
                })
              }

              filteredMessages2 = _.reverse(filteredMessages2)
              newMsgLogs = _.concat(newMsgLogs, filteredMessages2)
            }
          } else {
            break
          }
          if (responseTemp[i].meta !== undefined && responseTemp[i].meta.previous === undefined) {
            break
          }
          if (
            i === constants.messages_filter_export_call_limit - 1 &&
            responseTemp[constants.messages_filter_export_call_limit - 1].meta !== undefined &&
            responseTemp[constants.messages_filter_export_call_limit - 1].meta.previous !==
              undefined &&
            responseTemp[constants.messages_filter_export_call_limit - 1].meta.previous.id !==
              undefined
          ) {
            searchResultsExceedsLimit = true
          }
        }

        if (searchResultsExceedsLimit) {
          yield put({
            type: actions.SET_STATE,
            payload: {
              messageSearchExceedsLimit: true,
              messageSearchLogsLoading: false,
            },
          })
          window.triggerNotification(
            'Message logs are huge for the selected dates. Please reduce the date range to search.',
            'info',
          )
        } else {
          yield put({
            type: actions.SET_STATE,
            payload: {
              messageSearchLogs: newMsgLogs,
              messageSearchExceedsLimit: false,
              messageSearchLogsLoading: false,
            },
          })
        }
      } else {
        yield put({
          type: actions.SET_STATE,
          payload: {
            messageSearchLogs: [],
            messageSearchExceedsLimit: false,
            messageSearchLogsLoading: false,
          },
        })
      }
    } catch (error) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          messageSearchLogs: [],
          messageSearchExceedsLimit: false,
          messageSearchLogsLoading: false,
        },
      })
      window.triggerNotification('Failed to search messages', 'error')
    }
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        messageSearchLogs: [],
        messageSearchExceedsLimit: false,
        messageSearchLogsLoading: false,
      },
    })
  }
}

export function* GET_MESSAGE_EXPORT_LOGS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      messageExportLogsLoading: true,
      messageExportAllExceedsLimit: false,
    },
  })
  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings
  const responseTemp = []

  try {
    const success = yield call(
      exportMessageLogs,
      payload.data,
      getAppHost(payload.appSettings),
      'current',
    )
    let searchResultsExceedsLimit = false
    if (success && success.data) {
      let filteredMessages = _.filter(success.data, function fn(m) {
        return (
          m.category === 'message' ||
          m.category === 'agentic' ||
          (m.category === 'custom' && m.type !== 'extension_human-moderation')
        )
      })

      filteredMessages = _.reverse(filteredMessages)
      let newMsgLogs = filteredMessages
      responseTemp.push(success)

      for (let i = 1; i < constants.messages_filter_export_call_limit; i += 1) {
        if (
          responseTemp[i - 1].meta !== undefined &&
          responseTemp[i - 1].meta.previous !== undefined &&
          responseTemp[i - 1].meta.previous.id !== undefined
        ) {
          responseTemp[i] = yield call(
            exportMessageLogs,
            payload.data,
            getAppHost(payload.appSettings),
            'previous',
            responseTemp[i - 1].meta.previous.sentAt,
            responseTemp[i - 1].meta.previous.id,
          )
          if (responseTemp[i] && responseTemp[i].data) {
            let filteredMessages2 = _.filter(responseTemp[i].data, function fn(m) {
              return (
                m.category === 'message' ||
                (m.category === 'custom' && m.type !== 'extension_human-moderation')
              )
            })

            filteredMessages2 = _.reverse(filteredMessages2)
            newMsgLogs = _.concat(newMsgLogs, filteredMessages2)
          }
        } else {
          break
        }
        if (responseTemp[i].meta !== undefined && responseTemp[i].meta.previous === undefined) {
          break
        }
        if (
          i === constants.messages_filter_export_call_limit - 1 &&
          responseTemp[constants.messages_filter_export_call_limit - 1].meta !== undefined &&
          responseTemp[constants.messages_filter_export_call_limit - 1].meta.previous !==
            undefined &&
          responseTemp[constants.messages_filter_export_call_limit - 1].meta.previous.id !==
            undefined
        ) {
          searchResultsExceedsLimit = true
        }
      }

      if (searchResultsExceedsLimit) {
        const intent = _.join(
          [
            constants.ManualOutreachIntents['export-messages-exceeding-100k-request'],
            payload.data.id,
          ],
          ' / ',
        )
        const post = { intent }
        yield call(manualOutreach, post)
        yield put({
          type: actions.SET_STATE,
          payload: {
            messageExportAllExceedsLimit: true,
            messageExportLogsLoading: false,
          },
        })
      } else {
        yield put({
          type: actions.SET_STATE,
          payload: {
            messageExportLogs: newMsgLogs,
            messageExportLogsLoading: false,
            messageExportAllExceedsLimit: false,
          },
        })
      }
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          messageExportLogs: [],
          messageExportLogsLoading: false,
          messageExportAllExceedsLimit: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        messageExportLogs: [],
        messageExportLogsLoading: false,
        messageExportAllExceedsLimit: false,
      },
    })
    window.triggerNotification('Failed to export messages', 'error')
  }
}

export function* GET_MESSAGE_BY_ID({ payload }) {
  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(messageGet, id, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          messageActive: success.data,
        },
      })
    }

    return success
  } catch (error) {
    window.triggerNotification('Failed to fetch message', 'error')
  }
}

export default function* messagesSaga() {
  yield all([
    takeEvery(actions.GET_MESSAGE_LOGS, GET_MESSAGE_LOGS),
    takeEvery(actions.GET_MESSAGE_CATEGORIES, GET_MESSAGE_CATEGORIES),
    takeEvery(actions.GET_GROUP_MESSAGE_LOGS, GET_GROUP_MESSAGE_LOGS),
    takeEvery(actions.GET_MOD_MESSAGE_LOGS, GET_MOD_MESSAGE_LOGS),
    takeEvery(actions.DELETE_MESSAGE_LOG, DELETE_MESSAGE_LOG),
    takeEvery(actions.APPROVE_MOD_MESSAGE, APPROVE_MOD_MESSAGE),
    takeEvery(actions.REJECT_MOD_MESSAGE, REJECT_MOD_MESSAGE),
    takeEvery(actions.DELETE_GROUP_MESSAGE_LOG, DELETE_GROUP_MESSAGE_LOG),
    takeLatest(actions.GET_MESSAGE_SEARCH_LOGS, GET_MESSAGE_SEARCH_LOGS),
    takeEvery(actions.GET_MESSAGE_EXPORT_LOGS, GET_MESSAGE_EXPORT_LOGS),
    takeEvery(actions.GET_MESSAGE_BY_ID, GET_MESSAGE_BY_ID),
  ])
}
